export default "__VITE_ASSET__CgC10FYz__"